module.exports = __webpack_public_path__ + "media/images/Client-active-b8540051e7b55b6b2435fb90894d6cba.png";